import axios from 'axios'

export default {
  getStatus () {
    return axios.get('status')
  },
}
